import {
  Box, useTheme,
} from '@mui/material';
import { Outlet } from 'react-router';
import { DashboardLayoutProvider } from '@/contexts/DashboardLayoutContext';

import Header from './Header';
import Sidebar from './Sidebar';
import Footer from '@/content/components/common/Footer';
import UploadManager from '@/content/components/common/UploadManager';
import SkipToMainContent from '@/content/components/common/Accessibility/SkipToMainContent';

interface DashboardLayoutProps {
  withSidebar?: boolean;
}

const DashboardLayout = ({ withSidebar = false }: DashboardLayoutProps) => {
  const theme = useTheme();

  return (
    <DashboardLayoutProvider>
      <SkipToMainContent />
      <Box
        sx={{
          flex: 1,
          height: '100%',
          background: theme.colors.alpha.white[100],
        }}
      >
        <Header withSidebar={withSidebar} />
        {withSidebar && <Sidebar />}
        <Box
          component="main"
          id="main-content"
          tabIndex={-1}
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flex: 1,
            pt: `${theme.header.height}`,
            [theme.breakpoints.up('lg')]: { ml: withSidebar ? `${theme.sidebar.width}` : 0 },
            background: theme.colors.alpha.white[100],
          }}
        >
          <Box
            sx={{
              display: 'block',
              minHeight: 'calc(100vh - 180px)',
            }}
          >
            <Outlet />
          </Box>
          <Footer />
        </Box>
      </Box>
      {/*  TODO: move the UploadManager somewhere else if needed for insession call too */}
      <UploadManager />
    </DashboardLayoutProvider>
  );
};

export default DashboardLayout;
